import { createAction, createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const enhanceRequest = createRequest(constants.enhance);
export const enhanceSuccess = createSuccess(constants.enhance);
export const enhanceFailure = createFailure(constants.enhance);

export const acceptEnhancementRequest = createRequest(constants.acceptEnhancement);
export const acceptEnhancementSuccess = createSuccess(constants.acceptEnhancement);
export const acceptEnhancementFailure = createFailure(constants.acceptEnhancement);

export const usageRequest = createRequest(constants.usage);
export const usageSuccess = createSuccess(constants.usage);
export const usageFailure = createFailure(constants.usage);

export const settingsRequest = createRequest(constants.settings);
export const settingsSuccess = createSuccess(constants.settings);
export const settingsFailure = createFailure(constants.settings);

export const updateSettingsRequest = createRequest(constants.updateSettings);
export const updateSettingsSuccess = createSuccess(constants.updateSettings);
export const updateSettingsFailure = createFailure(constants.updateSettings);

export const dismissEnhancement = createAction(constants.dismissEnhancement);

export const requestAiUsage = usageRequest;
export const requestAiSettings = settingsRequest;
export const enhanceWithAi = enhanceRequest;
export const acceptAiEnhancement = acceptEnhancementRequest;
export const updateAiSettings = updateSettingsRequest;
